module.exports = __webpack_public_path__ + "media/images/devices/device-feature-logs-d884a5cebaa7b1fc39c214f07948d307.png";